import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import './add-product.scss';

function AddProductButton(props) {
  const intl = useIntl();
  const { buttonState, prependPrice, onClick } = props;

  return (
    <div className={`${buttonState.wrapperClass} ${buttonState.actionClassName || ''}`}>
      <button
        aria-label={intl.formatMessage({ id: buttonState.ariaLabel })}
        type="button"
        className={`${buttonState.wrapperClass}-button`}
        onClick={onClick}
        disabled={!!buttonState.disabled}
      >
        <span className={`${buttonState.wrapperClass}-button-text`}>
          {prependPrice && (
            <span className={`${buttonState.wrapperClass}-button-text--prepend`}>{prependPrice} &nbsp;&nbsp;</span>
          )}
          {buttonState.buttonText}
          <span className={`${buttonState.wrapperClass}-button-icon ${buttonState.icon || ''}`} />
        </span>
        <span className={`${buttonState.wrapperClass}-hover-text`}>{buttonState.hoverText}</span>
      </button>
    </div>
  );
}

AddProductButton.defaultProps = {
  prependPrice: null,
  buttonState: {},
};

AddProductButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  prependPrice: PropTypes.string,
  buttonState: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool])),
};

export default AddProductButton;
